import qs from "qs";
import constants from "../constants";
import apiClient from "./apiClient";
import {BaechaWorkDayStatusEnum, MhType} from "../types/Type";
import BaljuDTO from "../containers/BaechaList/MakeBaecha/dto/BaljuDTO";
import {BaechaWorkDay} from "../types/BaechaWorkDay";
import {GetBaechaListParams} from "../containers/BaechaList2/BaechaList2.interface";
import Constants from "../constants";
import {removeNil} from "../util/format";

export const fetchBaechaDataAPI = async ({
	                         baechaNo,
	                         groupName,
	                         baljuMemberId,
	                         sujuMemberId,
	                         status,
	                         page,
	                         limit = constants.PAGE_SIZE,
                         }: {
	baechaNo?: string;
	groupName?: string;
	baljuMemberId?: string;
	sujuMemberId?: string;
	status?: string;
	page: number,
	limit: number,
}) => {
	const offset = (page - 1) * limit;
	const query = qs.stringify({baechaNo, groupName, baljuMemberId, sujuMemberId, status, offset, limit });
	const res = await apiClient.get(`/api/admin/common/baecha/list?${query}`);
	return res.data;
};

export const fetchBaechaDataAPI2 = async (params: GetBaechaListParams) => {
	const { offset = 0, limit = Constants.PAGE_SIZE, ...rest } = params;

	const query = qs.stringify({
		...rest,
		offset,
		limit,
	}, {
		skipNulls: true,
	});
	console.log(query);
	const res = await apiClient.get(`/api/admin/common/baecha/list2?${query}`);
	return res.data;
};

// baechaId 넣으면 callPass[], baechaWorkDayData[], baechaUpdateHistoryData[] fetch
export const fetchCallPassBaechaWorkDayDataBaechaUpdateHistoryDataAPI = async (baechaId: string) => {
	const res = await apiClient.get(`/api/admin/common/baecha/${baechaId}`);
	return res.data;
};

export const fetchBaechaWorkDayAPI = async (baechaId: string) => {
	const res = await apiClient.get(`/api/admin/business/baecha/${baechaId}/workDay/list`);
	return res.data;
};

export const fetchBaechaUpdateHistoryAPI = async (baechaId: string) => {
	const res = await apiClient.get(`/api/admin/business/baecha/${baechaId}/updateHistory`);
	return res.data;
};

export const addBaechaWorkDayAPI = async ({ baechaId, mhType, price, overtimePrice, workDate }: {
	baechaId: string,
	mhType: MhType,
	price: number,
	overtimePrice?: number,
	workDate?: any,
}) => {
	const res = await apiClient.post(`/api/admin/business/baecha/${baechaId}/workDay/add`, {
		mhType,
		price,
		overtimePrice,
		workDate,
	});
	return res.data;
};

export const updateBaechaWorkDayAPI = async ({
	baechaId,
	baechaWorkDayId,
	mhType,
	price,
	overtimePrice,
	workDate,
}: {
	baechaId: string;
	baechaWorkDayId: string;
	mhType?: MhType;
	price?: number;
	overtimePrice?: number;
	workDate?: any;
}) => {
	const payload = removeNil({
		baechaWorkDayId,
		mhType,
		price,
		overtimePrice,
		workDate,
	})

	const res = await apiClient.put(
		`/api/admin/business/baecha/${baechaId}/workDay/update`,
		payload
	);

	return res.data;
};

export const doneBaechaWorkDayAPI = async ({ baechaId, baechaWorkDayId, doneMemberId }: {
	baechaId: string;
	baechaWorkDayId: string,
	doneMemberId: string;
}) => {
	const res = await apiClient.put(`/api/admin/business/baecha/${baechaId}/workDay/done`, {
		baechaId,
		baechaWorkDayId,
		doneMemberId,
	});
	return res.data;
};

export const deleteBaechaWorkDayAPI = async ({ baechaId, baechaWorkDayId }: {
	baechaId: string;
	baechaWorkDayId: string;
}) => {
	const res = await apiClient.delete(`/api/admin/business/baecha/${baechaId}/workDay/delete`, {
		data: {
			baechaWorkDayId,
		},
	});
	return res.data;
};

export const cancelBaechaAPI = async (baechaId: string) => {
	const res = await apiClient.post(`/api/admin/business/baecha/${baechaId}/cancel`);
	return res.data;
};

export const createBaljuAPI = async (baljuDTO: BaljuDTO) => {
	const res = await apiClient.post(`/api/admin/business/baecha/balju`, {
		data: {
			...baljuDTO,
		}
	});
	return res.data;
};

export const calcFeeAPI = async (baechaId: string, baechaWorkDayList: BaechaWorkDay[]) => {
	const res = await apiClient.post(`/api/baecha/${baechaId}/workDay/calcFee`, { baechaWorkDayList });
	return res.data;
}

export const getChatMessageByBaechaIdAPI = async (baechaId: string) => {
	const res = await apiClient.get(`/api/chat/baecha/${baechaId}`);
	return res.data;
};

export const updateBaechaWorkDayStatus = async ({
	baechaId,
	baechaWorkDayId,
	status,
	reason,
}: {
	baechaId: string;
	baechaWorkDayId: string;
	status: BaechaWorkDayStatusEnum;
	reason?: string;
}) => {
	const res = await apiClient.put(`/api/admin/business/baecha/${baechaId}/workDay/status`, {
		baechaWorkDayId,
		baechaWorkDayStatus: status,
		reason,
	});
	return res.data;
};
